import Vehicle from './Vehicle'
import { getVehicleDisplayName } from 'lib/utils/store/vehicle'
import * as Nope from 'lib/utils/validation/Nope'
import * as Yup from 'yup'

export default class DisabledVehicle extends Vehicle {
    static create (vehicle) {
        return new DisabledVehicle(vehicle)
    }

    getPrimaryDetailsValidationSchema () {
        return Nope.schema({
            vehicleType: Yup.string(),
            name: Nope.vehicleName(),
            regNumber: Nope.registerNumber(),
            isFinnishRegNumber: Yup.boolean(),
        })
    }

    getPrimaryDetailsInitialValues () {
        return {
            vehicleType: this.getVehicleTypeId() || '',
            name: this.vehicle.name || '',
            regNumber: this.vehicle.regNumber || '',
            isFinnishRegNumber: this.getIsFinnishRegNumber(),
        }
    }

    getPrimaryDetailsFieldsLayoutSchema () {
        return {
            layout: [
                {
                    type: 'formElementGroup',
                    classNames: 'cols-2',
                    fields: ['regNumber', 'isFinnishRegNumber', 'name'],
                },
            ]
        }
    }

    getPrimaryDetailsFieldsSchema (t) {
        return {
            fields: [
                {
                    name: 'regNumber',
                    type: 'string',
                    inputType: 'text',
                    fieldProps: {
                        label: t('vehicleProfile:regNumber'),
                        placeholder: this.vehicle.regNumber,
                        validate: (value, formValues) => this.validateRegNumber(value, formValues),
                    },
                },
                {
                    name: 'isFinnishRegNumber',
                    type: 'boolean',
                    inputType: 'checkbox',
                    fieldProps: {
                        label: t('vehicleProfile:sections.primary.isFinnishRegNumber'),
                        size: 'large'
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    inputType: 'text',
                    fieldProps: {
                        label: t('vehicleProfile:vehicleNickname'),
                        description: t('vehicleProfile:vehicleNicknameDescription'),
                        placeholder: getVehicleDisplayName(this.vehicle, t),
                    },
                },
            ]
        }
    }
}
